import { Components } from '@mui/material';

export const MuiTextField: Components['MuiTextField'] = {
  defaultProps: {
    variant: 'outlined',
  },
  styleOverrides: {
    root: {
      variants: [
        {
          props: { variant: 'filled' },
          style: {
            // MUI doesn't allow custom variants for TextFields, so we use the
            // className as a variant: https://medium.com/@victorgonz96/create-material-ui-textfield-variants-2616b673cce0
            '&&&.watchduty-filled-nolabel': {
              '.MuiInputBase-root': {
                borderRadius: 8,
              },
              input: {
                paddingTop: '4px',
              },
              '.MuiInputAdornment-root': {
                marginTop: '0',
              },
              '& :before, & :after, &:hover :before, &:hover :after': {
                borderBottom: 'none',
              },
            },
          },
        },
      ],
    },
  },
};
